<template>
    <section id="page-dashboard">
        <v-row class="mb-4" v-if="hasViewGraphic">
            <v-col cols="12">
                <Graphics
                    :metricsInformation="metricsInformation"
                    :key="componentKey"
                />
            </v-col>
        </v-row>

        <YoutubeTutorial :moduleId="$globals.MODULES.MY_GARAGE.ID" />

        <div
            class="d-flex justify-center justify-sm-start flex-wrap"
            :class="{ mobile: $vuetify.breakpoint.xsOnly }"
        >
            <div v-for="mod in availableModules" :key="mod.moduleName">
                <template v-if="mod.isVisible">
                    <a
                        @click="clickMenuItem(mod)"
                        class="module-container rounded mb-4"
                        :class="mod.isActive ? '' : 'disabled-a'"
                        :data-cy="`dashboard${mod.moduleId}`"
                        style="cursor: pointer"
                        :id="
                            mod.moduleId +
                            '_' +
                            mod.moduleName.replace(/\s/g, '_')
                        "
                    >
                        <img
                            :src="mod.icon"
                            :alt="mod.moduleName"
                            onload="SVGInject(this)"
                        />
                        <h2 class="text-start">{{ mod.moduleName }}</h2>
                    </a>
                </template>
            </div>
        </div>

        <vehicle-search-component
            :show="modal.show"
            :mode="2"
            @modal-closed="modalClosed"
        />
    </section>
</template>

<script>
import mixinMenus from "@mixins/b2b/menus.js";

export default {
    mixins: [mixinMenus],
    components: {
        Graphics: () => import("@components/b2b/dashboard/Graphics"),
        VehicleSearchComponent: () =>
            import(
                "@components/shared/widgets/vehicle-identification/VehicleSearchComponent"
            ),
        YoutubeTutorial: () =>
            import("@components/b2b/widgets/YoutubeTutorial"),
    },
    data() {
        return {
            componentKey: 0,
            domain: "",
            fuels: [],
            segment: [],
        };
    },
    watch: {
        metricsInformation() {
            this.componentKey++;
        },
    },
    computed: {
        metricsInformation() {
            return this.$store.getters["dashboard/getMetrics"]
                .metricsInformation;
        },
        hasViewGraphic() {
            return this.$store.getters["dashboard/getMetrics"].hasViewGraphic;
        },
    },
    methods: {
        async clearShoppingCart() {
            let processNummber =
                this.$store.getters["vehicleIdentification/getState"]
                    .processNumber;
            this.$store.commit("budget/setB2bClearShoppingCart");
            this.$store.commit("budget/setB2bClearShoppingCartToStep2");
            localStorage.removeItem("@copyShoppingCart");
            localStorage.removeItem("@shoppingCartTotals");
            localStorage.removeItem("budgetB2b");
            await this.$nextTick();
            const shoppingCartCopy = {
                operations: [],
                parts: [],
            };
            const payloadBudgetStartedBy = {
                budgetId: null,
                budgetName: "",
            };
            const shoppingCartTotals = {
                operations: { totals: {} },
                parts: { totals: {} },
            };
            this.$store.commit(
                "budget/setBudgetStartedBy",
                payloadBudgetStartedBy
            );
            this.$store.commit("budget/setShoppingCartCopy", shoppingCartCopy);
            this.$store.commit(
                "budget/setShoppingCartTotalsClear",
                shoppingCartTotals
            );
            this.$store.commit(
                "budget/setCurrentProcessNumberByCar",
                processNummber
            );
            this.$store.commit(
                "activeReception/setActiveReceptionServicesAssociatedQuotationId",
                null
            );
            this.$store.commit("budget/setB2bCurrentStep", 1);
            localStorage.removeItem("@copyShoppingCart");
            localStorage.removeItem("@shoppingCartTotals");
            localStorage.removeItem("budgetB2b");
            this.$store.commit("budget/setClearBudgetSummary", {});
            this.$store.commit("budget/setB2bClearShoppingCart");
            this.$store.commit("loadings/setStateLoadingTemplate", false);
            await this.$nextTick();
        },
    },
    beforeMount() {
        this.fuels = {
            title: {
                subtext: "Maio 2019",
                left: "center",
            },
            tooltip: {
                trigger: "item",
            },
            legend: {
                bottom: 10,
                left: "center",
            },
            series: [
                {
                    type: "pie",
                    radius: ["40%", "70%"],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: "#fff",
                        borderWidth: 2,
                    },
                    label: {
                        show: false,
                        position: "center",
                    },
                    labelLine: {
                        show: false,
                    },
                    data: [
                        { value: 1048, name: "Diesel" },
                        { value: 735, name: "Gasolina" },
                        { value: 580, name: "Hibrid/Elet" },
                    ],

                    color: [
                        this.$vuetify.theme.parsedTheme.primary.base,
                        this.$vuetify.theme.parsedTheme.primary.lighten1,
                        this.$vuetify.theme.parsedTheme.primary.lighten2,
                    ],
                },
            ],
        };

        this.segment = {
            xAxis: {
                type: "category",
                data: ["Peças", "Serv", "Repar", "Veic", "Outros"],
            },
            yAxis: {
                axisLabel: {
                    fontSize: 11,
                    formatter: function (value, index) {
                        var value;
                        if (value >= 1000) {
                            value = value / 1000 + "k";
                        } else if (value < 1000) {
                            value = value;
                        }
                        return value;
                    },
                },
            },
            series: [
                {
                    data: [
                        {
                            value: 885000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .base,
                            },
                        },
                        {
                            value: 585000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .lighten1,
                            },
                        },
                        {
                            value: 385000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .lighten2,
                            },
                        },
                        {
                            value: 185000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .lighten3,
                            },
                        },
                        {
                            value: 85000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .lighten4,
                            },
                        },
                        {
                            value: 10000,
                            itemStyle: {
                                color: this.$vuetify.theme.parsedTheme.primary
                                    .lighten5,
                            },
                        },
                    ],
                    type: "bar",
                },
            ],
        };
    },
    mounted() {
        if (this.$helpers.onlyVRMActive()) {
            this.$router.push({ name: "vehicleIdentification" });
        }

        this.domain = this.$store.getters["auth/getState"].domain;

        this.getGarageIndicators();
        if (this.$route.params.plate) {
            this.$store.commit(
                "vehicleIdentification/setVehicleIdentificationPlateSearch",
                { plate: this.$route.params.plate }
            );
        }

        if (this.$route.params && this.$route.params.clearCartAgain) {
            setTimeout(() => {
                this.clearShoppingCart();
            }, 3000);
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";

#page-dashboard {
    .static-cards {
        cursor: pointer;
    }

    a {
        text-decoration: none;
    }

    .disabled-a {
        opacity: 0.5;
        &:hover {
            opacity: 0.5;
            color: white !important;
        }
    }

    .module-container {
        cursor: pointer;
        display: flex;
        align-items: center;
        padding: 20px;
        margin-right: 20px;
        max-width: 325px;
        min-width: 325px;
        max-height: 200px;
        border-left: 10px solid $grey;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        -moz-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        -o-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        -webkit-box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.06);
        background: white;

        h2 {
            text-transform: uppercase;
            font-weight: 400;
            font-size: 13px;
            letter-spacing: 0.75px;
        }

        &:hover {
            border-left: 10px solid var(--v-primary-base);
            box-shadow: 0 2px 7px var(--v-primary-lighten1);
        }

        svg {
            height: 100%;
            width: 40%;
            max-width: 30%;
            min-width: 30%;
            margin-right: 30px;
        }
    }

    span {
        opacity: 0.5;
    }

    .mobile {
        .module-container {
            margin-bottom: 15px;
            margin-right: 0;
        }
    }
}
.span-btn-modal {
    color: #06a6e0;
    text-transform: capitalize;
    font-weight: bold;
}

.hr-modal-slider {
    background: white;
}

::v-deep .v-window__next {
    top: calc(85% - 20px) !important;
    margin: 0px 390px !important;
}

::v-deep .v-window__prev {
    top: calc(85% - 20px) !important;
}

::v-deep .v-chip {
    background: white !important;
    color: #555 !important;
    margin-right: 10px !important;
    margin-bottom: 16px !important;
}

.modal--base-modal {
    ::v-deep .v-card__title {
        padding: 0px 24px 10px !important;
    }
}

::v-deep .metric-title {
    background-color: var(--v-primary-base) !important;
}
</style>

